import { MutationFunction, useMutation } from '@apollo/client';

import { IDeleteComboRequest, IDeleteComboResponse } from './interfaces';
import { DELETE_COMBO } from './schema';

export const useDeleteCombo = (): MutationFunction<
  IDeleteComboResponse,
  IDeleteComboRequest
> => {
  const [deleteCombo] = useMutation<IDeleteComboResponse, IDeleteComboRequest>(
    DELETE_COMBO,
    {
      update: (cache, { data }) => {
        const combo = data?.deleteCombo;

        if (!combo) return;

        cache.evict({
          id: cache.identify(combo),
        });
        cache.gc();
      },
      optimisticResponse: ({ id }) => ({ deleteCombo: { id } }),
    }
  );

  return deleteCombo;
};
